<template>
  <div>
    <Banner />
    <v-container class="px-lg-12" fluid>
      <v-row>
        <v-col cols="12" class="py-12">
          <v-card class="pa-6">
            <v-card-text>
              <h3 :class="`${$vuetify.breakpoint.xsOnly ? 'text-h5' : 'text-h3'} primary--text`">
                <span class="font-weight-bold">
                  HealthView Capital Partners
                </span> is focused exclusively on
                <em class="font-weight-bold secondary--text">
                  growing investments in three targeted areas...
                </em>
              </h3>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-for="i in callouts" :key="i.title" cols="12" md="4" class="pb-12">
          <v-card height="100%">
            <v-card-title class="justify-center text-lg-h5 text-md-h6 text-uppercase" :class="`${i.theme_color}--text`">
              <div class="text-center">
                {{ i.title }}
              </div>
            </v-card-title>
            <v-card-text class="text-h6 grey--text text--darken-2">
              {{ i.body }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Banner from '@/components/core/Banner'
export default {
  name: 'Index',
  components: {
    Banner,
  },
  metaInfo: {
    title: 'HealthView Capital',
    titleTemplate: null,
    meta: [
      {description: 'Guided by decades of diverse healthcare operating experience, we actively work with portfolio companies to build local and regional businesses into a national platform.'}
    ]
  },
  data() {
    return {
      title: 'Home Page',
      callouts: [
        {
          title: 'Healthcare Service Delivery',
          body:
            'Concentrating on systems and processes that deliver healthcare to patients.',
          theme_color: 'primary',
        },
        {
          title: 'Patient-Driven Outcomes',
          body:
            "Including any service that improves a patient's quality of life.",
          theme_color: 'secondary',
        },
        {
          title: 'Healthcare Information Services',
          body:
            'Efficiently distributing new technologies, particularly for in-home monitoring and medical devices.',
          theme_color: 'primary',
        },
      ],
    }
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.v-card__title {
    word-break: break-word;
    height: 80px;
}
</style>
